module.exports = __webpack_public_path__ + "img/icon_omni_hub.8101b4e2.png";